import MetaTags from 'components/MetaTags'

import ChooseService from 'containers/SelectService/ChooseService'

export default function Index() {
  const metaTitle = '24 FIX | แจ้งซ่อม'
  const metaDescription = '24 FIX | แจ้งซ่อม'

  return (
    <>
      <MetaTags title={metaTitle} description={metaDescription} noIndex />

      <ChooseService />
    </>
  )
}
